import { render, staticRenderFns } from "./InvoiceSq.vue?vue&type=template&id=8b8a788c&scoped=true"
import script from "./InvoiceSq.vue?vue&type=script&lang=js"
export * from "./InvoiceSq.vue?vue&type=script&lang=js"
import style0 from "./InvoiceSq.vue?vue&type=style&index=0&id=8b8a788c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8a788c",
  null
  
)

export default component.exports